import { isEmpty } from 'lodash';
import { DIGITS_PATTERN, EMPTY_NUMBER_FIELD_VALUE } from '../constants/patterns';

export const updateCalculationFormAge = (value, setValue, setAge) => {
  if (DIGITS_PATTERN.test(value)) {
    const newAge = Number(value || 0);
    setValue('age', newAge, true);
    setAge(newAge);
  }
  if (isEmpty(value)) {
    setValue('age', EMPTY_NUMBER_FIELD_VALUE, true);
    setAge(EMPTY_NUMBER_FIELD_VALUE);
  }
};
